module.exports = __webpack_public_path__ + "static/img/banner3.8a44506a.jpg";